export default class ActionLogger {
  constructor() {
    //get User login from server
    this.userLogin = "";
    this.userId = 0;

    this._operations = [];
    this._steps = [];

    this.log = {};
  }

  /**
   *    * @param phone
   */
  setUser(phone) {}

  /**
   *
   * @param operationName
   * @returns {boolean}
   */
  addOperation(operationName) {
    if (this._haveOperation(operationName)) {
      return false;
    }
    this.log[operationName] = {};
    this._operations.push(operationName);
  }

  /**
   *
   * @param operationName
   * @param stepName
   * @returns {boolean}
   */
  addStep(operationName, stepName) {
    if (!this._haveOperation(operationName)) {
      return false;
    }

    if (this._haveStep(stepName)) {
      return false;
    }
    this.log[operationName][stepName] = {};
    this._steps.push(stepName);
  }

  /**
   *
   * @param operationName
   * @returns {boolean}
   */
  operationFillingStart(operationName) {
    if (!this._haveOperation(operationName)) {
      return false;
    }
    this.log[operationName].timeStart = Date.now();
    this.log[operationName].timeZone = new Date().getTimezoneOffset() / 60;
  }

  /**
   *
   * @param operationName
   * @returns {boolean}
   */
  operationFillingEnd(operationName) {
    if (!this._haveOperation(operationName)) {
      return false;
    }
    this.log[operationName].timeEnd = Date.now();
  }

  /**
   *
   * @param operationName
   * @param stepName
   * @returns {boolean}
   */
  stepFillingStart(operationName, stepName) {
    if (!this._haveOperation(operationName)) {
      return false;
    }
    if (!this._haveStepInOperation(operationName, stepName)) {
      return false;
    }
    this.log[operationName][stepName].timeStart = Date.now();
    this.log[operationName][stepName].timeZone =
      new Date().getTimezoneOffset() / 60;
    this.log[operationName][stepName].actions = [];
  }

  /**
   *
   * @param operationName
   * @param stepName
   * @returns {boolean}
   */
  stepFillingEnd(operationName, stepName) {
    if (!this._haveOperation(operationName)) {
      return false;
    }
    if (!this._haveStepInOperation(operationName, stepName)) {
      return false;
    }
    this.log[operationName][stepName].timeEnd = Date.now();
  }

  /**
   *
   * @param operationName
   * @param stepName
   * @param fieldName
   * @param payload
   * @returns {boolean}
   */
  addUserAction(operationName, stepName, fieldName, payload) {
    if (!this._haveOperation(operationName)) {
      return false;
    }

    if (!this._haveStepInOperation(operationName, stepName)) {
      return false;
    }
    let actionsLength = this.log[operationName][stepName].actions.length - 1;

    this._parsePayload(
      this.log[operationName][stepName].actions[actionsLength],
      payload
    );
  }

  /**
   *
   * @param operationName
   * @param stepName
   * @param fieldName
   * @returns {boolean}
   */
  startUserAction(operationName, stepName, fieldName) {
    if (!this._haveOperation(operationName)) {
      return false;
    }

    if (!this._haveStepInOperation(operationName, stepName)) {
      return false;
    }
    let actionsLength = this.log[operationName][stepName].actions.length - 1;
    this.log[operationName][stepName].actions.push({
      fieldName: fieldName,
      timeStart: Date.now(),
      events: []
    });
  }

  /**
   *
   * @param operationName
   * @param stepName
   * @returns {boolean}
   */
  endUserAction(operationName, stepName) {
    if (!this._haveOperation(operationName)) {
      return false;
    }

    if (!this._haveStepInOperation(operationName, stepName)) {
      return false;
    }
    let actionsLength = this.log[operationName][stepName].actions.length - 1;
    let currentLog = this.log[operationName][stepName].actions[actionsLength];
    currentLog.timeEnd = Date.now();
    currentLog.totalTime = (currentLog.timeEnd - currentLog.timeStart) / 1000;
  }

  /**
   *
   * @param log
   * @param payload
   * @private
   */
  _parsePayload(log, payload) {
    let event = {
      actionType: payload.actionType
    };

    switch (payload.actionType) {
      case "copy":
      case "cut": {
        event.selectionText = payload.target;
        break;
      }

      case "paste": {
        event.pasteText = payload.target;
        break;
      }

      case "remove": {
        event.keyPressed = payload.key;
        break;
      }
    }

    log.events.push(event);
  }

  /**
   *
   * @param operationName
   * @returns {boolean}
   * @private
   */
  _haveOperation(operationName) {
    return this._operations.indexOf(operationName) > -1;
  }

  /**
   *
   * @param stepName
   * @returns {boolean}
   * @private
   */
  _haveStep(stepName) {
    return this._steps.indexOf(stepName) > -1;
  }

  /**
   *
   * @param operationName
   * @param stepName
   * @returns {boolean}
   * @private
   */
  _haveStepInOperation(operationName, stepName) {
    if (!this._haveOperation(operationName)) {
      return false;
    }

    return typeof this.log[operationName][stepName] === "object";
  }

  /**
   *
   * @returns {{}}
   */
  getLog() {
    return this.log;
  }
}
const data = {
  log: {
    REGISTRATION: {
      timeStart: "",
      timeEnd: "",
      total: "",
      steps: {
        personalInfo: {
          timeStart: "",
          timeEnd: "",
          total: "",
          fields: [
            {
              fieldName: "",
              timeStart: "",
              timeEnd: "",
              total: "",

              keyPressed: {
                copy: {
                  data: ""
                }
              },

              errors: [{ time: "", data: "", errorText: "" }]
            }
          ]
        },
        address: {},
        employment: {},
        contacts: {},
        verify: {},
        videoVerify: {},
        refining: {},
        conditions: {}
      }
    }
  }
};
